import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from "@angular/router";
import { UserService } from "@services/user.service";
import { switchMap } from "rxjs/operators";
import { Observable, of } from "rxjs";

@Injectable({ providedIn: "root" })
export class RedirectIfAuthenticatedGuard  {
  constructor(private userService: UserService, private router: Router) {}

  public canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    return this.userService.getUser().pipe(
      switchMap((user) => {
        if (!user) {
          return of(true);
        }

        this.router.navigate(["/planning"]);
        return of(false);
      })
    );
  }
}
